import {z} from 'zod'

export const partialPickupRawSchema = z.object({
    still_out_count: z.number(),
    summary: z.string(),
})

export type PartialPickupRaw = z.infer<typeof partialPickupRawSchema>
export type PartialPickup = {stillOutCount: number; summary: string}

export function mapPartialPickup(raw: PartialPickupRaw | null | undefined): PartialPickup | null {
    return raw ? {stillOutCount: raw.still_out_count, summary: raw.summary} : null
}

export function partialPickupText(partialPickup: PartialPickup): string {
    return `Partial pickup, still on rent: ${partialPickup.summary}`
}

export function stayOnRentWarning(count: number): string {
    const items = count === 1 ? '1 item stays' : `${count} items stay`
    return `${items} on rent at this site. Job marked Partial pickup until returned.`
}
